var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNairaCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5837 28.5V16.6397C16.5836 16.3876 16.6672 16.1427 16.8215 15.9433C16.9757 15.7439 17.1918 15.6014 17.4358 15.5382C17.6798 15.475 17.9379 15.4946 18.1696 15.5939C18.4012 15.6933 18.5933 15.8668 18.7157 16.0872L25.285 27.9128C25.4073 28.1332 25.5994 28.3067 25.8311 28.4061C26.0627 28.5054 26.3208 28.525 26.5648 28.4618C26.8088 28.3986 27.0249 28.2561 27.1792 28.0567C27.3334 27.8573 27.4171 27.6124 27.417 27.3603V15.5M14.417 19.8333H29.5836M14.417 24.1667H29.5836",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaCircular);
export default __webpack_public_path__ + "static/media/naira_circular.982f3f336867c7a70281ad418c1d85c9.svg";
export { ForwardRef as ReactComponent };